import { TableRow, TableCell, Typography, Box } from '@mui/material';
import {
  formatNumberWithCommas,
  timeConverter
} from 'src/common/config/FunctionHelper';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { keywordResearchDashBoardCss } from '../keywordResearch/keywordResearchCSS';
import { CustomTooltip } from '../keywordResearch/CustomTooltip';
import { BackLinkAllTexts } from './BackLinkAllTexts';

const CircularProgressWithLabel = (props) => {
  const score = Math.round(props.value);

  let colorCode = 'var(--color-error-orange)';
  if (score <= 50) {
    colorCode = 'var(--color-error-orange)'; //red
  } else if (score >= 51 && score <= 65) {
    colorCode = 'var(--color-warning-dark)'; //orange
  } else if (score >= 66 && score <= 75) {
    colorCode = 'var(--color-warning-yellow)'; //yellow
  } else if (score >= 76 && score <= 94) {
    colorCode = 'var(--color-warning-yellow-green)'; //chartreuse
  } else {
    colorCode = 'var(--color-secondary)'; //green
  }
  return (
    <div className="flex items-center space-x-2">
      <Box sx={{ position: 'relative' }}>
        <Box
          sx={{
            width: 7,
            height: 7,
            borderRadius: '50%',
            backgroundColor: colorCode
          }}
        />
        {/* )} */}
      </Box>

      <p
        style={{
          fontFamily: 'Inter',
          fontSize: 'var(--font-size-14)',
          fontWeight: 500,
          lineHeight: 'var(--line-height-20)',
          textAlign: 'left',
          color: 'var(--color-text-near-black)'
        }}
      >
        {' '}
        {props.value}
      </p>
    </div>
  );
};

const CircularProgressWithLabelSpamScore = (props) => {
  const score = Math.round(props.value);

  let colorCode = 'var(--color-secondary)';
  if (score <= 30) {
    colorCode = 'var(--color-secondary)'; //green
  } else if (score >= 31 && score <= 60) {
    colorCode = 'var(--color-warning-dark)'; //orange
  } else if (score >= 61 && score <= 100) {
    colorCode = 'var(--color-error-orange)'; //red
  } else {
    colorCode = 'var(--color-secondary)'; //green
  }
  return (
    <div className="flex items-center space-x-2">
      <Box sx={{ position: 'relative' }}>
        <Box
          sx={{
            width: 7,
            height: 7,
            borderRadius: '50%',
            backgroundColor: colorCode
          }}
        />
        {/* )} */}
      </Box>

      <p
        style={{
          fontFamily: 'Inter',
          fontSize: 'var(--font-size-14)',
          fontWeight: 500,
          lineHeight: 'var(--line-height-20)',
          textAlign: 'left',
          color: 'var(--color-text-near-black)'
        }}
      >
        {' '}
        {`${props.value}%`}
      </p>
    </div>
  );
};
const BackLinksRow = ({ row }) => {
  let userDetails: any = useSelector(
    (state: RootState) => state?.counter?.userDetails
  );
  const dateFormat = userDetails?.date_format || 'DD/MM/YYYY';
  return (
    <TableRow
      sx={{
        background: 'rgb(250,250,250)',
        height: '40px',
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: 'var(--color-bg-purple-tint)'
        },
        '& .MuiTableCell-root': {
          borderBottom: '0px',
          borderTop: '1px solid rgba(0,0,0,0.06)'
        }
      }}
    >
      {/* Referring Page + URL */}
      <TableCell
        sx={{
          width: '500px',
          paddingTop: '10px !important',
          paddingBottom: '10px !important'
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontWeight: 400,
            fontSize: 'var(--font-size-14)',
            lineHeight: 'var(--line-height-20)',
            color: 'var(--color-google-link)',
            marginBottom: '8px',
            maxWidth: '40rem',
            wordBreak: 'break-word'
          }}
        >
          {row?.referringPage}
        </Typography>
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: 'var(--line-height-14)',
            color: '#4D5156',
            maxWidth: '40rem',
            wordBreak: 'break-all'
          }}
        >
          {row?.referringUrl}
        </Typography>
      </TableCell>

      {/* DR */}
      <TableCell>
        <Box
          sx={{
            fontFamily: 'Inter',
            fontWeight: 500,
            fontSize: 'var(--font-size-14)',
            lineHeight: 'var(--line-height-20)',
            color: 'var(--color-text-near-black)',
            textAlign: 'center'
          }}
        >
          {row?.dr !== '' && row?.dr !== null
            ? formatNumberWithCommas(row?.dr)
            : '-'}
          {/*<CircularProgressWithLabel value={row?.dr} />*/}
        </Box>
      </TableCell>

      {/* Spam Score with Dot */}
      <TableCell>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '5px'
          }}
        >
          <Box
            sx={{
              fontFamily: 'Inter',
              fontWeight: 500,
              fontSize: 'var(--font-size-14)',
              lineHeight: 'var(--line-height-20)',
              color: 'var(--color-text-near-black)'
            }}
          >
            <CircularProgressWithLabelSpamScore value={row?.spamScore} />
          </Box>
        </Box>
      </TableCell>

      {/* Anchor Text + Link Attribute */}
      <TableCell
        sx={{ paddingTop: '10px !important', paddingBottom: '10px !important' }}
      >
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontWeight: 400,
            fontSize: 'var(--font-size-14)',
            lineHeight: 'var(--line-height-20)',
            color: 'var(--color-google-link)',
            mb: 0.5,
            maxWidth: '40rem',
            wordBreak: 'break-word'
          }}
        >
          {row?.anchorText}
        </Typography>
        {row?.itemType && (
          <CustomTooltip
            title={
              <Box>
                <Typography sx={keywordResearchDashBoardCss?.customTollTipText}>
                  {row?.itemType == BackLinkAllTexts?.attrType.image
                    ? BackLinkAllTexts?.backlinkAttrImageTooltip
                    : BackLinkAllTexts?.backlinkAttrContentTooltip}
                </Typography>
              </Box>
            }
            placement="top"
            arrow
          >
            <Typography
              sx={{
                display: 'inline-block',
                padding: '4px 10px',
                fontFamily: 'Inter',
                fontWeight: 400,
                fontSize: 'var(--font-size-14)',
                lineHeight: 'var(--line-height-20)',
                color: 'var(--color-primary)',
                background: 'var(--color-bg-muted-alt)',
                borderRadius: '4px'
              }}
            >
              {row?.itemType}
            </Typography>
          </CustomTooltip>
        )}
        {row?.targetUrl && (
          <Typography
            sx={{
              mt: 0.5,
              fontFamily: 'Inter',
              fontWeight: 400,
              fontSize: '12px',
              lineHeight: 'var(--line-height-14)',
              color: '#4D5156',
              maxWidth: '40rem',
              wordBreak: 'break-all'
            }}
          >
            {row?.targetUrl || ''}
          </Typography>
        )}
      </TableCell>

      <TableCell>
        <Typography
          sx={{
            display: 'inline-block',
            padding: '4px 16px',
            fontFamily: 'Inter',
            fontWeight: 400,
            fontSize: 'var(--font-size-14)',
            lineHeight: 'var(--line-height-20)',
            color: 'var(--color-primary)',
            background: 'var(--color-bg-muted-alt)',
            borderRadius: '4px'
          }}
        >
          {row?.linkAttribute}
        </Typography>
      </TableCell>

      {/* First Seen */}
      <TableCell>
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontWeight: 500,
            fontSize: 'var(--font-size-14)',
            lineHeight: 'var(--line-height-20)',
            color: 'var(--color-text-near-black)'
          }}
        >
          {row?.firstSeen ? timeConverter(row?.firstSeen, dateFormat) : '-'}
        </Typography>
      </TableCell>

      {/* Lost */}
      <TableCell sx={{ minWidth: '110px' }}>
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontWeight: 500,
            fontSize: 'var(--font-size-14)',
            lineHeight: 'var(--line-height-20)',
            color: 'var(--color-text-near-black)'
          }}
        >
          {row?.lost ? 'Yes' : 'No'}
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export default BackLinksRow;
